export const levelNames = [
    ["Новичок", 0],
    ["Помощник", 1000],
    ["Профи", 2000],
    ["Эксперт", 4000],
    ["Мастер", 8000],
    ["Гуру", 12000],
];
